/** The photo to show for an art: the one flagged primary, else the first. */
function primaryPhoto(art) {
  const photos = art && art.photos
  if (!photos || !photos.length) return null
  return photos.find(p => p && p.primary) || photos[0] || null
}

/**
 * URL for card-sized renditions (panel cards, marker popup, gallery teasers).
 * Prefers the 640px thumbnail when the payload carries one; the full-size
 * image_url is for the artwork gallery, which reads photos directly.
 */
export function primaryPhotoUrl(art) {
  const chosen = primaryPhoto(art)
  if (!chosen) return null
  return chosen.thumb_url || chosen.image_url || null
}

/**
 * URL for marker-sized renditions (44px pins, cluster bubbles, nearby list).
 * Prefers the square pin rendition, degrading through the thumbnail to the
 * full-size image so old cached payloads keep working.
 */
export function primaryPhotoPinUrl(art) {
  const chosen = primaryPhoto(art)
  if (!chosen) return null
  return chosen.pin_url || chosen.thumb_url || chosen.image_url || null
}
